import React, { useEffect, useState } from 'react';
import { PhoneIcon } from 'lucide-react';
import { business } from '../data/business';
import { TricolorStripe } from './TricolorStripe';
export function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`sticky top-0 z-50 w-full bg-cream/95 backdrop-blur transition-[box-shadow,border-color] duration-200 ease-out border-b ${scrolled ? 'border-line shadow-[0_4px_16px_-8px_rgba(31,26,23,0.18)]' : 'border-transparent'}`} data-id="element-90" data-mp="qx5k7ur4pfn6">
      <TricolorStripe className="h-1.5" data-id="element-91" data-mp="zzol49bcti6s" />
      <div className="mx-auto flex h-[58px] max-w-6xl items-center justify-between px-4 sm:px-6" data-id="element-92" data-mp="2gasitjrbjwzs">
        <a href="#top" className="font-display text-2xl leading-none text-salsa sm:text-3xl" data-id="element-93" data-mp="2bda75llx33o3">
          Vegas Taco Truck
        </a>
        <nav aria-label="Main" className="flex items-center gap-2 sm:gap-6" data-id="element-94" data-mp="29jaj7i6h2cai">
          <a href="#specials" className="hidden text-sm font-semibold text-ink hover:text-salsa transition-colors duration-150 sm:inline" data-id="element-95" data-mp="2ehvjfhlq4vyy">
            Especiales
          </a>
          <a href="#menu" className="hidden text-sm font-semibold text-ink hover:text-salsa transition-colors duration-150 sm:inline" data-id="element-96" data-mp="2ofrnxqk5oso3">
            Menú
          </a>
          <a href="#hours" className="hidden text-sm font-semibold text-ink hover:text-salsa transition-colors duration-150 sm:inline" data-id="element-97" data-mp="1vsx856yaahgy">
            Horario
          </a>
          <a href={business.phoneHref} className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-salsa px-4 py-2 text-sm font-bold text-white hover:bg-salsa-dark transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-salsa focus-visible:ring-offset-2 focus-visible:ring-offset-cream" data-id="element-98" data-mp="25jruebbj5h2e">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-99" data-mp="1013piq3zclb2" />
            <span className="hidden sm:inline" data-id="element-100" data-mp="1er1fnblgzl2w">Call to order</span>
            <span className="sm:hidden" data-id="element-101" data-mp="1eq9kg1vsbpd5">Call</span>
          </a>
        </nav>
      </div>
    </header>;
}